module.exports = __webpack_public_path__ + "static/media/0224_IMG_LES_MURS_LAGOON_W_VLA2100_HORIZONTALE.3ffb1dfd.png";